<!-- Page Container -->
<div class="container fade-in-up">
  <!-- Loading Overlay moved inside to anchor correctly -->
  <!-- Local Branded Spinner -->
  <!-- Local Branded Spinner - Replaced with Skeleton for better UX -->
  <div class="form-grid" *ngIf="loader">
    <!-- Skeleton Pickup Section -->
    <div class="form-section">
      <div class="skeleton-label"></div>
      <div class="po-wrapper">
        <div class="po-input-wrapper" style="width: 100%;">
          <div class="skeleton-input"></div>
        </div>
      </div>
      <div class="form-group">
        <div class="skeleton-label"></div>
        <div class="skeleton-input"></div>
      </div>
      <div class="form-group">
        <div class="skeleton-label"></div>
        <div class="skeleton-input"></div>
      </div>
      <div class="form-row-3">
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
      </div>
      <div class="phone-row">
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
      </div>
      <div class="form-group notes-group">
        <div class="skeleton-label"></div>
        <div class="skeleton-textarea"></div>
      </div>
    </div>

    <!-- Skeleton Delivery Section -->
    <div class="form-section">
      <div class="skeleton-label"></div>
      <div class="po-wrapper">
        <div class="po-input-wrapper" style="width: 100%;">
          <div class="skeleton-input"></div>
        </div>
      </div>
      <div class="form-group">
        <div class="skeleton-label"></div>
        <div class="skeleton-input"></div>
      </div>
      <div class="form-group">
        <div class="skeleton-label"></div>
        <div class="skeleton-input"></div>
      </div>
      <div class="form-row-3">
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
      </div>
      <div class="phone-row">
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="form-group">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
      </div>
      <div class="form-group notes-group">
        <div class="skeleton-label"></div>
        <div class="skeleton-textarea"></div>
      </div>
    </div>
  </div>
  <!-- Header with Back Button -->
  <div class="page-header"
    style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; display: none;">
    <h2 style="margin: 0;">
      <span *ngIf="isAddMode">Add Order</span>
      <span *ngIf="!isAddMode">Edit Order</span>
    </h2>
    <!-- <div class="back-to-list">
      <a *ngIf="!isAddMode" (click)="navigateToDetail()">
        <button (click)="normalMode()">Back to Details</button>
      </a>
      <a *ngIf="isAddMode" routerLink='/admin/dashboard'>
        <button (click)="normalMode()">Back to List</button>
      </a>
    </div> -->
  </div>

  <!-- Form Grid -->
  <form class="form-grid" *ngIf="!loader">
    <!-- PICKUP SECTION -->
    <div class="form-section">
      <div class="section-title">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="section-icon">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
        </svg>
        Pickup Details
        <span class="section-badge">FROM</span>
      </div>

      <!-- Mode Checkboxes & Purchase Order -->
      <div class="po-wrapper">
        <div class="mode-checkboxes">
          <div class="mode-checkbox-item">
            <input type="checkbox" id="pickupAutoMode" [checked]="orderForm.pickup.mode === 'auto'"
              (change)="togglePickupMode($event)" [attr.disabled]="(isManualChecked || !warehouseData) ? true : null"
              [ngClass]="warehouseData ? '' : 'disabled-custom'">
            <label for="pickupAutoMode" class="checkbox-label">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="mode-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              Auto
            </label>
          </div>
          <div class="mode-checkbox-item">
            <input type="checkbox" id="pickupManualMode" [checked]="orderForm.pickup.mode === 'manual'"
              (change)="toggleDeliveryModeManual($event)">
            <label for="pickupManualMode" class="checkbox-label">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="mode-icon">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
              </svg>
              Manual
            </label>
          </div>
        </div>
        <div class="po-input-wrapper">
          <input type="text" class="po-input"
            [class.error]="isSubmitted && errors['purchaseOrder'] && !isCheckedWarehous?.[0]?.pickup"
            placeholder="Purchase Order #" [(ngModel)]="orderForm.pickup.purchaseOrder"
            [ngModelOptions]="{standalone: true}" (click)="onClickOfPickup($event)"
            [ngClass]="isCheckedWarehous[0].pickup ? 'input-disabled':''" [disabled]="isCheckedWarehous?.[0]?.pickup"
            (keydown)="isAlphaNumeric($event, 'PO')" (keydown.enter)="$event.preventDefault()"
            (input)="validateNewUIForm()">
          <div class="error-message" *ngIf="isSubmitted && errors['purchaseOrder'] && !isCheckedWarehous?.[0]?.pickup"
            [class.show]="errors['purchaseOrder']">
            {{errors['purchaseOrder']}}
          </div>
          <!-- <div *ngIf="isSubmitted && f['po'].errors" class="error-message show">
            <div *ngIf="f['po'].errors['required']">
              PO is required
            </div>
          </div> -->
        </div>
      </div>

      <!-- Company Name -->
      <div class="form-group">
        <label class="form-label">Company Name<span class="required-star">*</span></label>
        <div class="combo-wrapper">
          <input type="text" class="combo-input" [class.error]="isSubmitted && errors['pickupCompany']"
            placeholder="{{pickup_company_name_placeholder}}" [(ngModel)]="orderForm.pickup.company"
            [ngModelOptions]="{standalone: true}" (focus)="showPickupCompanyDropdown = true"
            (input)="filterPickupCompanies();validateNewUIForm()" (blur)="showPickupCompanyDropdown = false"
            (click)="onClickOfPickup($event);searchResults();companyName($event, 'pickup')"
            (keyup.enter)="companyName($event, 'pickup')" autocomplete="off" (keydown)="handlePickupKeyDown($event)">
          <div class="combo-dropdown-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          </div>
          <div class="combo-dropdown" #pickupDropdown
            [class.show]="showPickupCompanyDropdown && (filteredPickupCompanies.length > 0 || isPickupCompanySearching)">
            <div class="combo-option" *ngFor="let company of filteredPickupCompanies; let i = index"
              [class.active]="i === highlightedPickupIndex" 
              (mouseenter)="highlightedPickupIndex = i"
              (mousedown)="selectPickupCompany(company)">
              {{company}}
            </div>
            <div class="combo-option searching" *ngIf="isPickupCompanySearching">
              Searching...
            </div>
          </div>
          <!-- <div class="combo-dropdown" [class.show]="showPickupCompanyDropdown && filteredPickupCompanies.length > 0">
            <div class="combo-option" *ngFor="let company of filteredPickupCompanies"
              (mousedown)="selectPickupCompany(company)">
              {{company}}
            </div>
          </div> -->
        </div>
        <div class="error-message" *ngIf="isSubmitted && errors['pickupCompany']"
          [class.show]="errors['pickupCompany']">
          {{errors['pickupCompany']}}
        </div>
        <!-- <div *ngIf="isSubmitted && f['pickup_company_name'].errors" class="error-message show">
          <div *ngIf="f['pickup_company_name'].errors['required']">
            Company Name is required
          </div>
        </div> -->
      </div>

      <!-- Pickup Address -->
      <div class="form-group">
        <label class="form-label">Pickup Address<span class="required-star">*</span></label>
        <div class="combo-wrapper">
          <input type="text" class="combo-input" [class.error]="isSubmitted && errors['pickupAddress']"
            placeholder="Pickup Address" [(ngModel)]="orderForm.pickup.address" [ngModelOptions]="{standalone: true}"
            (focus)="showPickupAddressDropdown = true" (input)="filterPickupAddresses();validateNewUIForm()"
            (blur)="showPickupAddressDropdown = false"
            (click)="onClickOfPickup($event);searchResults();companyName($event, 'pickup')"
            (keyup.enter)="companyName($event, 'pickup')" autocomplete="off"
            (keydown)="handlePickupAddressKeyDown($event)">
          <div class="combo-dropdown-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          </div>
          <div class="combo-dropdown"
            [class.show]="showPickupAddressDropdown && (filteredPickupAddresses.length > 0 || isPickupAddressSearching)"
            #pickupAddressDropdown>
            <div class="combo-option" *ngFor="let address of filteredPickupAddresses; let i = index"
              [class.active]="i === highlightedPickupAddressIndex" 
              (mouseenter)="highlightedPickupAddressIndex = i"
              (mousedown)="selectPickupAddress(address)">
              {{address}}
            </div>
            <div class="combo-option searching" *ngIf="isPickupAddressSearching">
              Searching...
            </div>
          </div>
        </div>
        <div class="error-message" *ngIf="isSubmitted && errors['pickupAddress']"
          [class.show]="errors['pickupAddress']">
          {{errors['pickupAddress']}}
        </div>
        <!-- <div *ngIf="isSubmitted && f['pickup_address'].errors" class="error-message show">
          <div *ngIf="f['pickup_address'].errors['required']">
            Pickup Address is required
          </div>
        </div> -->
      </div>

      <!-- Date, Time & Add Address -->
      <div class="form-row-3">
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Date<span class="required-star">*</span></label>
          <input type="date" class="form-input" [class.error]="isSubmitted && errors['pickupDate']"
            [(ngModel)]="orderForm.pickup.date" [ngModelOptions]="{standalone: true}"
            [min]="minDate ? (minDate | date:'yyyy-MM-dd') : null" (click)="onClickOfPickup($event)">
          <div class="error-message" *ngIf="isSubmitted && errors['pickupDate']" [class.show]="errors['pickupDate']">
            {{errors['pickupDate']}}
          </div>
          <!-- <div *ngIf="isSubmitted && f['pickup_date'].errors" class="error-message show">
            <div *ngIf="f['pickup_date'].errors['required']">
              Date is required
            </div>
          </div> -->
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Time</label>
          <!-- <input type="time" class="form-input" 
            [(ngModel)]="orderForm.pickup.time"
            [ngModelOptions]="{standalone: true}"
            (click)="onClickOfPickup($event)"
            (keydown.enter)="$event.preventDefault()"> -->
          <input class="form-input mb-0" placeholder="--:-- --" readonly matInput (click)="onClickOfPickup($event)"
            name="pickupTime" [format]="12" [ngxTimepicker]="pickupTimePicker" [(ngModel)]="orderForm.pickup.time"
            (keydown.enter)="$event.preventDefault()">
          <ngx-material-timepicker #pickupTimePicker [defaultTime]="getTime()" [format]="12" timeFormat="HH:mm"
            (timeSet)="onPickupTimeSet($event)"></ngx-material-timepicker>
          <span *ngIf="orderForm.pickup.time && orderForm.pickup.time.toString().length > 0" class="remove-time"
            (click)="removeTime('pickup')">&times;</span>
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">&nbsp;</label>
          <button class="btn-add-address" (click)="addNewAddress('pickup');onClickOfPickup($event)" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" style="width: 16px; height: 16px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Add Address
          </button>
        </div>
      </div>

      <!-- Contact, Email & Service Time -->
      <div [ngClass]="(isCheckedWarehous[1].dely || orderForm.pickup.mode === 'manual') ? 'form-row-3' : 'form-row'">
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Contact Name<span class="required-star">*</span></label>
          <input type="text" class="form-input" [class.error]="isSubmitted && errors['pickupContact']"
            placeholder="Contact Name" [(ngModel)]="orderForm.pickup.contact" [ngModelOptions]="{standalone: true}"
            (input)="capitalizeContactName($event, 'pickup');validateNewUIForm()" (click)="onClickOfPickup($event)"
            (keydown.enter)="$event.preventDefault()">
          <div class="error-message" *ngIf="isSubmitted && errors['pickupContact']"
            [class.show]="errors['pickupContact']">
            {{errors['pickupContact']}}
          </div>
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Email</label>
          <input type="email" class="form-input" [class.error]="isSubmitted && errors['pickupEmail']"
            placeholder="Email" [(ngModel)]="orderForm.pickup.email" [ngModelOptions]="{standalone: true}"
            (click)="onClickOfPickup($event)" (keydown.enter)="$event.preventDefault()" (input)="validateNewUIForm()">
          <div class="error-message" *ngIf="isSubmitted && errors['pickupEmail']" [class.show]="errors['pickupEmail']">
            {{errors['pickupEmail']}}
          </div>
        </div>
        <div class="form-group" style="margin-bottom: 0;"p
          *ngIf="isCheckedWarehous[1].dely || orderForm.pickup.mode === 'manual'">
          <label class="form-label">Service Time</label>
          <select class="form-select" [(ngModel)]="orderForm.pickup.timeInterval" [ngModelOptions]="{standalone: true}"
            (click)="onClickOfPickup($event)">
            <option value="" disabled>Service Time</option>
            <option *ngFor="let time of timeInterval" [value]="time.value">
              {{time.label}}
            </option>
          </select>
        </div>
      </div>

      <!-- Phone Numbers -->
      <div class="phone-row">
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Code<span class="required-star">*</span></label>
          <select class="form-select" [(ngModel)]="orderForm.pickup.countryCode" [ngModelOptions]="{standalone: true}"
            (change)="onCountryCodeChange(orderForm.pickup.countryCode)" (click)="onClickOfPickup($event)">
            <option *ngFor="let country of countryCodes" [value]="country.dial_code">
              {{ country.code }} {{ country.dial_code }}
            </option>
          </select>
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Phone Number<span class="required-star">*</span></label>
          <input type="tel" class="form-input" [class.error]="isSubmitted && errors['pickupPhone']"
            placeholder="Ph Number" [(ngModel)]="orderForm.pickup.phone" [ngModelOptions]="{standalone: true}"
            maxlength="10" (input)="validatePhone($event, 'pickup');validateNewUIForm()"
            (click)="onClickOfPickup($event)" (keypress)="onKeyPress($event)" (wheel)="onWheel($event)"
            (keydown.enter)="$event.preventDefault()">
          <div class="error-message" *ngIf="isSubmitted && errors['pickupPhone']" [class.show]="errors['pickupPhone']">
            {{errors['pickupPhone']}}
          </div>
          <!-- <div *ngIf="isSubmitted && f['pickup_phone'].errors" class="error-message show">
            <div *ngIf="f['pickup_phone'].errors['required']">
              Phone Number is required
            </div>
            <div *ngIf="f['pickup_phone'].errors['pattern']">
              Phone Number must be 10 digits
            </div>
          </div> -->
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Alternate Phone Number</label>
          <input type="tel" class="form-input" [class.error]="isSubmitted && errors['pickupAltPhone']"
            placeholder="Alternate Ph Number" [(ngModel)]="orderForm.pickup.altPhone"
            [ngModelOptions]="{standalone: true}" maxlength="10" (input)="validatePhone($event)"
            (click)="onClickOfPickup($event)" (keypress)="onKeyPress($event)" (wheel)="onWheel($event)"
            (keydown.enter)="$event.preventDefault()">
          <div class="error-message" *ngIf="isSubmitted && errors['pickupAltPhone']"
            [class.show]="errors['pickupAltPhone']">
            {{errors['pickupAltPhone']}}
          </div>
        </div>
      </div>

      <!-- Checkboxes -->
      <div class="form-row-inline" *ngIf="isCheckedWarehous[1].dely || orderForm.pickup.mode === 'manual'">
        <div class="mode-checkbox-item">
          <input type="checkbox" id="pickupSignatureRequired" [(ngModel)]="orderForm.pickup.signatureRequired"
            [ngModelOptions]="{standalone: true}" (change)="Signaturereq('pickup', orderForm.pickup.signatureRequired)"
            class="checkboxInput">
          <label for="pickupSignatureRequired" class="form-label mb-0">
            Signature required
          </label>
        </div>
        <div class="delpu-group">
          <label class="form-label mb-0">
            Del/PU
          </label>
          <div class="combo-wrapper delpu-custom-dropdown">
            <div class="form-select custom-select-trigger" (click)="showPickupDelpuDropdown = !showPickupDelpuDropdown"
              (blur)="showPickupDelpuDropdown = false" tabindex="0">
              {{ orderForm.pickup.firstDelivery === 0 ? 'Select' : orderForm.pickup.firstDelivery }}
              <div class="combo-dropdown-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
            </div>
            <div class="combo-dropdown delpu-dropdown" [class.show]="showPickupDelpuDropdown">
              <div class="combo-option" *ngFor="let item of visiblePickupDelpu; let last = last"
                (mousedown)="selectPickupDelpu(item.value)">
                <span>{{item.label}}</span>
                <span class="plus-icon inline-plus" 
                  *ngIf="last && visiblePickupDelpuCount < Delpu.length"
                  (mousedown)="loadMorePickupDelpu($event)">+</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Special Instructions -->
      <div class="form-group notes-group">
        <label class="form-label">Special Instructions</label>
        <textarea class="form-textarea" placeholder="Notes" [(ngModel)]="orderForm.pickup.notes"
          [ngModelOptions]="{standalone: true}" (input)="updatePickupNotesCount();validateNewUIForm()"
          (click)="onClickOfPickup($event)" maxlength="200" rows="3"></textarea>
        <div class="char-counter">{{pickupNotesRemaining}} characters remaining</div>
      </div>
    </div>

    <!-- DELIVERY SECTION -->
    <div class="form-section">
      <div class="section-title">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="section-icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
        </svg>
        Delivery Details
        <span class="section-badge">TO</span>
      </div>

      <!-- Mode Checkboxes & Order Number -->
      <div class="po-wrapper">
        <div class="mode-checkboxes">
          <div class="mode-checkbox-item">
            <input type="checkbox" id="deliveryAutoMode" [checked]="orderForm.delivery.mode === 'auto'"
              (change)="toggleDeliveryMode($event)" [ngClass]="warehouseData ? '' : 'disabled-custom'"
              [attr.disabled]="(isManualChecked1 || !warehouseData) ? true : null">
            <label for="deliveryAutoMode" class="checkbox-label">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="mode-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              Auto
            </label>
          </div>
          <div class="mode-checkbox-item">
            <input type="checkbox" id="deliveryManualMode" [checked]="orderForm.delivery.mode === 'manual'"
              (change)="toggleDeliveryModeManual($event)">
            <label for="deliveryManualMode" class="checkbox-label">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="mode-icon">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
              </svg>
              Manual
            </label>
          </div>
        </div>
        <div class="po-input-wrapper">
          <input type="text" class="po-input"
            [class.error]="isSubmitted && errors['orderNumber'] && !isCheckedWarehous?.[1]?.dely"
            placeholder="Order Number #" [(ngModel)]="orderForm.delivery.orderNumber"
            [ngModelOptions]="{standalone: true}" (click)="onClickOfDely($event)"
            [ngClass]="isCheckedWarehous[1].dely ? 'input-disabled':''" [disabled]="isCheckedWarehous?.[1]?.dely"
            (keydown)="isAlphaNumeric($event, 'ON')" (keydown.enter)="$event.preventDefault()"
            (input)="validateNewUIForm()">
          <div *ngIf="isSubmitted && errors['orderNumber'] && !isCheckedWarehous?.[1]?.dely" class="error-message"
            [class.show]="errors['orderNumber']">
            {{errors['orderNumber']}}
          </div>
          <!-- <div *ngIf="isSubmitted && f['order_no'].errors" class="error-message show">
            <div *ngIf="f['order_no'].errors['required']">
              ON is required
            </div>
          </div> -->
        </div>
      </div>

      <!-- Company Name -->
      <div class="form-group">
        <label class="form-label">Company Name<span class="required-star">*</span></label>
        <div class="combo-wrapper">
          <input type="text" class="combo-input" [class.error]="isSubmitted && errors['deliveryCompany']"
            placeholder="{{dely_company_name_placeholder}}" [(ngModel)]="orderForm.delivery.company"
            [ngModelOptions]="{standalone: true}" (focus)="showDeliveryCompanyDropdown = true"
            (input)="filterDeliveryCompanies();validateNewUIForm()" (blur)="showDeliveryCompanyDropdown = false"
            (click)="onClickOfDely($event);searchResults();companyName($event, 'dely')"
            (keyup.enter)="companyName($event, 'dely')" autocomplete="off" (keydown)="handleKeyDown($event)">
          <div class="combo-dropdown-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          </div>
          <div class="combo-dropdown" #deliveryDropdown
            [class.show]="showDeliveryCompanyDropdown && (filteredDeliveryCompanies.length > 0 || isDeliveryCompanySearching)">
            <div class="combo-option" *ngFor="let company of filteredDeliveryCompanies; let i = index"
              [class.active]="i === highlightedIndex" 
              (mouseenter)="highlightedIndex = i"
              (mousedown)="selectDeliveryCompany(company)">
              {{company}}
            </div>
            <div class="combo-option searching" *ngIf="isDeliveryCompanySearching">
              Searching...
            </div>
          </div>


        </div>
        <div class="error-message" *ngIf="isSubmitted && errors['deliveryCompany']"
          [class.show]="errors['deliveryCompany']">
          {{errors['deliveryCompany']}}
        </div>
        <!-- <div *ngIf="isSubmitted && f['dely_company_name'].errors" class="error-message show">
          <div *ngIf="f['dely_company_name'].errors['required']">
            Company Name is required
          </div>
        </div> -->
      </div>

      <!-- Delivery Address -->
      <div class="form-group">
        <label class="form-label">Delivery Address<span class="required-star">*</span></label>
        <div class="combo-wrapper">
          <input type="text" class="combo-input" [class.error]="isSubmitted && errors['deliveryAddress']"
            placeholder="Delivery Address" [(ngModel)]="orderForm.delivery.address"
            [ngModelOptions]="{standalone: true}" (focus)="showDeliveryAddressDropdown = true"
            (input)="filterDeliveryAddresses();validateNewUIForm()" (blur)="showDeliveryAddressDropdown = false"
            (click)="onClickOfDely($event);searchResults();companyName($event, 'dely')"
            (keyup.enter)="companyName($event, 'dely')" autocomplete="off"
            (keydown)="handleDeliveryAddressKeyDown($event)">
          <div class="combo-dropdown-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          </div>
          <div class="combo-dropdown" #deliveryAddressDropdown
            [class.show]="showDeliveryAddressDropdown && (filteredDeliveryAddresses.length > 0 || isDeliveryAddressSearching)">
            <div class="combo-option" *ngFor="let address of filteredDeliveryAddresses; let i = index"
              [class.active]="i === highlightedDeliveryAddressIndex" 
              (mouseenter)="highlightedDeliveryAddressIndex = i"
              (mousedown)="selectDeliveryAddress(address)">
              {{address}}
            </div>
            <div class="combo-option searching" *ngIf="isDeliveryAddressSearching">
              Searching...
            </div>
          </div>
        </div>
        <div class="error-message" *ngIf="isSubmitted && errors['deliveryAddress']"
          [class.show]="errors['deliveryAddress']">
          {{errors['deliveryAddress']}}
        </div>
        <!-- <div *ngIf="isSubmitted && f['dely_address'].errors" class="error-message show">
          <div *ngIf="f['dely_address'].errors['required']">
            Delivery Address is required
          </div>
        </div> -->
      </div>

      <!-- Date, Time & Add Address -->
      <div class="form-row-3">
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Date<span class="required-star">*</span></label>
          <input type="date" class="form-input" [class.error]="isSubmitted && errors['deliveryDate']"
            [(ngModel)]="orderForm.delivery.date" [ngModelOptions]="{standalone: true}"
            [min]="minDate ? (minDate | date:'yyyy-MM-dd') : null" (click)="onClickOfDely($event)">
          <div class="error-message" *ngIf="isSubmitted && errors['deliveryDate']"
            [class.show]="errors['deliveryDate']">
            {{errors['deliveryDate']}}
          </div>
          <!-- <div *ngIf="isSubmitted && f['dely_date'].errors" class="error-message show">
            <div *ngIf="f['dely_date'].errors['required']">
              Date is required
            </div>
          </div> -->
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Time</label>
          <!-- <input type="time" class="form-input" 
            [(ngModel)]="orderForm.delivery.time"
            [ngModelOptions]="{standalone: true}"
            (click)="onClickOfDely($event)"
            (keydown.enter)="$event.preventDefault()"> -->

          <input class="form-input mb-0" placeholder="--:-- --" readonly matInput (click)="onClickOfDely($event)"
            name="delyTime" [format]="12" [ngxTimepicker]="delyTimePicker" [(ngModel)]="orderForm.delivery.time"
            (keydown.enter)="$event.preventDefault()">
          <ngx-material-timepicker #delyTimePicker [defaultTime]="getTime()" [format]="12" timeFormat="HH:mm"
            (timeSet)="onDelyTimeSet($event)"></ngx-material-timepicker>
          <span *ngIf="orderForm.delivery.time && orderForm.delivery.time.toString().length > 0" class="remove-time"
            (click)="removeTime('dely')">&times;</span>
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">&nbsp;</label>
          <button class="btn-add-address" (click)="addNewAddress('delivery');onClickOfDely($event)" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" style="width: 16px; height: 16px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Add Address
          </button>
        </div>
      </div>

      <!-- Contact, Email & Service Time -->
      <div
        [ngClass]="(isCheckedWarehous[0].pickup || orderForm.delivery.mode === 'manual') ? 'form-row-3' : 'form-row'">
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Contact Name<span class="required-star">*</span></label>
          <input type="text" class="form-input" [class.error]="isSubmitted && errors['deliveryContact']"
            placeholder="Contact Name" [(ngModel)]="orderForm.delivery.contact" [ngModelOptions]="{standalone: true}"
            (input)="capitalizeContactName($event, 'delivery');validateNewUIForm()" (click)="onClickOfDely($event)"
            (keydown.enter)="$event.preventDefault()">
          <div class="error-message" *ngIf="isSubmitted && errors['deliveryContact']"
            [class.show]="errors['deliveryContact']">
            {{errors['deliveryContact']}}
          </div>
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Email</label>
          <input type="email" class="form-input" [class.error]="isSubmitted && errors['deliveryEmail']"
            placeholder="Email" [(ngModel)]="orderForm.delivery.email" [ngModelOptions]="{standalone: true}"
            (click)="onClickOfDely($event)" (keydown.enter)="$event.preventDefault()" (input)="validateNewUIForm()">
          <div class="error-message" *ngIf="isSubmitted && errors['deliveryEmail']"
            [class.show]="errors['deliveryEmail']">
            {{errors['deliveryEmail']}}
          </div>
        </div>
        <div class="form-group" style="margin-bottom: 0;"
          *ngIf="isCheckedWarehous[0].pickup || orderForm.delivery.mode === 'manual'">
          <label class="form-label">Service Time</label>
          <select class="form-select" [(ngModel)]="orderForm.delivery.timeInterval"
            [ngModelOptions]="{standalone: true}" (click)="onClickOfDely($event)">
            <option value="" disabled>Service Time</option>
            <option *ngFor="let time of timeInterval" [value]="time.value">
              {{time.label}}
            </option>
          </select>
        </div>
      </div>

      <!-- Phone Numbers -->
      <div class="phone-row">
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Code<span class="required-star">*</span></label>
          <select class="form-select" [(ngModel)]="orderForm.delivery.countryCode" [ngModelOptions]="{standalone: true}"
            (change)="onCountryCodeChange(orderForm.delivery.countryCode)" (click)="onClickOfDely($event)">
            <option *ngFor="let country of countryCodes" [value]="country.dial_code">
              {{ country.code }} {{ country.dial_code }}
            </option>
          </select>
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Phone Number<span class="required-star">*</span></label>
          <input type="tel" class="form-input" [class.error]="isSubmitted && errors['deliveryPhone']"
            placeholder="Ph Number" [(ngModel)]="orderForm.delivery.phone" [ngModelOptions]="{standalone: true}"
            maxlength="10" (input)="validatePhone($event, 'delivery');validateNewUIForm()"
            (click)="onClickOfDely($event)" (keypress)="onKeyPress($event)" (wheel)="onWheel($event)"
            (keydown.enter)="$event.preventDefault()">
          <div class="error-message" *ngIf="isSubmitted && errors['deliveryPhone']"
            [class.show]="errors['deliveryPhone']">
            {{errors['deliveryPhone']}}
          </div>
          <!-- <div *ngIf="isSubmitted && f['dely_phone'].errors" class="error-message show">
            <div *ngIf="f['dely_phone'].errors['required']">
              Phone Number is required
            </div>
            <div *ngIf="f['dely_phone'].errors['pattern']">
              Phone Number must be 10 digits
            </div>
          </div> -->
        </div>
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Alternate Phone Number</label>
          <input type="tel" class="form-input" [class.error]="isSubmitted && errors['deliveryAltPhone']"
            placeholder="Alternate Ph Number" [(ngModel)]="orderForm.delivery.altPhone"
            [ngModelOptions]="{standalone: true}" maxlength="10" (input)="validatePhone($event)"
            (click)="onClickOfDely($event)" (keypress)="onKeyPress($event)" (wheel)="onWheel($event)"
            (keydown.enter)="$event.preventDefault()">
          <div class="error-message" *ngIf="isSubmitted && errors['deliveryAltPhone']"
            [class.show]="errors['deliveryAltPhone']">
            {{errors['deliveryAltPhone']}}
          </div>
        </div>
      </div>

      <!-- Checkboxes -->
      <div class="form-row-inline" *ngIf="isCheckedWarehous[0].pickup || orderForm.delivery.mode === 'manual'">
        <div class="mode-checkbox-item">
          <input type="checkbox" id="deliverySignatureRequired" [(ngModel)]="orderForm.delivery.signatureRequired"
            [ngModelOptions]="{standalone: true}"
            (change)="Signaturereq('delivery', orderForm.delivery.signatureRequired)" class="checkboxInput">
          <label for="deliverySignatureRequired" class="form-label mb-0">
            Signature required
          </label>
        </div>
        <div class="delpu-group">
          <label class="form-label mb-0">
            Del/PU
          </label>
          <div class="combo-wrapper delpu-custom-dropdown">
            <div class="form-select custom-select-trigger" (click)="showDelyDelpuDropdown = !showDelyDelpuDropdown"
              (blur)="showDelyDelpuDropdown = false" tabindex="0">
              {{ orderForm.delivery.firstDelivery === 0 ? 'Select' : orderForm.delivery.firstDelivery }}
              <div class="combo-dropdown-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
            </div>
            <div class="combo-dropdown delpu-dropdown" [class.show]="showDelyDelpuDropdown">
              <div class="combo-option" *ngFor="let item of visibleDelyDelpu; let last = last" (mousedown)="selectDelyDelpu(item.value)">
                <span>{{item.label}}</span>
                <span class="plus-icon inline-plus"
                  *ngIf="last && visibleDelyDelpuCount < Delpu.length"
                  (mousedown)="loadMoreDelyDelpu($event)">+</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Special Instructions -->
      <div class="form-group notes-group">
        <label class="form-label">Special Instructions</label>
        <textarea class="form-textarea" placeholder="Notes" [(ngModel)]="orderForm.delivery.notes"
          [ngModelOptions]="{standalone: true}" (input)="updateDeliveryNotesCount();validateNewUIForm()"
          (click)="onClickOfDely($event)" maxlength="200" rows="3"></textarea>
        <div class="char-counter">{{deliveryNotesRemaining}} characters remaining</div>
      </div>
    </div>
  </form>

  <!-- Action Buttons -->
  <div class="form-actions" *ngIf="!loader">
    <button class="btn btn-cancel" (click)="cancel()" type="button">Cancel</button>
    <button class="btn btn-submit" type="button" [disabled]="loading" (click)="submitOrder()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        style="width: 18px; height: 18px;" *ngIf="!loading">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
      <app-local-spinner *ngIf="loading" size="small" [blur]="false" [showText]="false"></app-local-spinner>
      <span *ngIf="isAddMode && !loading">Add Order</span>
      <span *ngIf="!isAddMode && !loading">Update Order</span>
      <span *ngIf="loading">Processing...</span>
    </button>
  </div>
</div>